import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as classes from './classes.module.scss';
import Const from '../../config/const';

const RATIO = Const.preview.ratio;

export default class CustomCrop extends PureComponent {
  static propTypes = {
    x: PropTypes.number,
    y: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    custom: PropTypes.bool.isRequired,
    dpi: PropTypes.number.isRequired,
    setCrop: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      startX: 0,
      startY: 0
    };
  }

  onMouseMoveStart = (e) => {
    const { clientX, clientY } = e;
    e.preventDefault();
    e.stopPropagation();
    this.setPosStart({ clientX, clientY });
  };

  onMouseMoveEnd = (e) => {
    const { clientX, clientY } = e;
    e.preventDefault();
    e.stopPropagation();
    this.setPosEnd({ clientX, clientY });
  };

  onMouseUpStart = (e) => {
    window.removeEventListener('mousemove', this.onMouseMoveStart);
    window.removeEventListener('mouseup', this.onMouseUpStart);
    const { clientX, clientY } = e;
    e.preventDefault();
    e.stopPropagation();
    this.setPosStart({ clientX, clientY });
  };

  onMouseUpEnd = (e) => {
    window.removeEventListener('mousemove', this.onMouseMoveEnd);
    window.removeEventListener('mouseup', this.onMouseUpEnd);
    const { clientX, clientY } = e;
    e.preventDefault();
    e.stopPropagation();
    this.setPosEnd({ clientX, clientY });
  };

  onMouseDownStart = (e) => {
    window.addEventListener('mousemove', this.onMouseMoveStart);
    window.addEventListener('mouseup', this.onMouseUpStart);
    const { clientX, clientY } = e;
    e.preventDefault();
    e.stopPropagation();
    this.setState({ startX: clientX, startY: clientY });
  };

  onMouseDownEnd = (e) => {
    window.addEventListener('mousemove', this.onMouseMoveEnd);
    window.addEventListener('mouseup', this.onMouseUpEnd);
    const { clientX, clientY } = e;
    e.preventDefault();
    e.stopPropagation();
    this.setState({ startX: clientX, startY: clientY });
  };

  setPosStart({ clientX, clientY }) {
    const { startX, startY } = this.state;
    const {
      dpi, setCrop, x, y, width, height
    } = this.props;
    const dx = (clientX - startX) / dpi;
    const dy = (clientY - startY) / dpi;
    setCrop({
      x: x + dx, y: y + dy, width, height
    });
    this.setState({ startX: clientX, startY: clientY });
  }

  setPosEnd({ clientX, clientY }) {
    const { startX, startY } = this.state;
    const {
      dpi, setCrop, x, y, width, height
    } = this.props;
    const dx = (clientX - startX) / dpi;
    const dy = (clientY - startY) / dpi;
    let newWidth = width + dx;
    let newHeight = height + dy;
    if (dx < dy) {
      newWidth = newHeight * RATIO;
    } else {
      newHeight = newWidth / RATIO;
    }
    setCrop({
      x, y, width: newWidth, height: newHeight
    });
    this.setState({ startX: clientX, startY: clientY });
  }

  calculateStyle() {
    const {
      x, y, width: wIn, height: hIn, dpi
    } = this.props;

    const left = (x || 0) * dpi;
    const top = (y || 0) * dpi;
    const width = (wIn || 0) * dpi;
    const height =  (hIn || 0) * dpi;

    return {
      box: {
        left, top, width, height
      },
      p0: {
        left: left - 2,
        top: top - 2
      },
      p1: {
        left: left + width - 4,
        top: top + height - 3
      }
    };
  }

  renderCustom() {
    const { box, p0, p1 } = this.calculateStyle();
    return (
      <>
        <div className={ classes.customArea } style={ box } />
        <div
          className={ classes.pin }
          style={ p0 }
          onMouseDown={ this.onMouseDownStart }
        />
        <div
          className={ classes.pin }
          style={ p1 }
          onMouseDown={ this.onMouseDownEnd }
        />
      </>
    );
  }

  render() {
    const { custom, width } = this.props;
    if (!width) {
      return null;
    }
    if (custom) {
      return this.renderCustom();
    }

    const { box } = this.calculateStyle();
    return (
      <div className={ classes.previewArea } style={ box } />
    );
  }
}
